<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClickTab"
        v-loading="loading"
      >
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="rentItemForm"
              :model="rentItem"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('rentItem.serialNo')">
                      {{ rentItem.serialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label :state="rentItem.workflowState">
                        {{ $t("rentStates." + rentItem.workflowState) }}
                      </state-label>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">
                      {{ rentItem.createAt }}
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="rentItem.finishAt != null">
                  <el-col :span="8">
                    <el-form-item :label="$t('rentItem.finishName')">
                      {{ rentItem.finishName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rentItem.finishAt')">
                      {{ rentItem.finishAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rentItem.finishRemark')">
                      {{ rentItem.finishRemark }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item :label="$t('rent.rentAt')">
                      {{ rentItem.startAt }} ～ {{ rentItem.endAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("text.productInfo") }}
                </legend>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">
                      {{ rentItem.productNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">
                      {{ rentItem.categoryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.quantity')">
                      {{ rentItem.quantity }} {{ rentItem.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.price2')">
                      {{ rentItem.price | currency }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset v-if="rentItem.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail :images="rentItem.images" list></thumbnail>
              </fieldset>
              <fieldset class="mgb15" v-if="rentItem.remark != null">
                <legend>
                  {{ $t("text.remark") }}
                </legend>
                <raw-html :content="rentItem.remark" type="richText" />
              </fieldset>
              <fieldset
                class="mgb15"
                v-if="
                  rentItem.workflowState == 'canceled' && rentItem.rentItemSon
                "
              >
                <legend>
                  {{ $t("rentItem.cancelInfo") }}
                </legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('rentItem.cancelName')">
                      {{ rentItem.rentItemSon.cancelName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rentItem.cancelAt')">
                      {{ rentItem.rentItemSon.cancelAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rentItem.cancelReason')">
                      {{ rentItem.rentItemSon.cancelReason }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
// import Thumbnail from "@/components/Thumbnail";
// import TinymceEditor from "@/components/TinymceEditor";

import StateLabel from "@/components/StateLabel";
import RentItem from "@/api/rentItem.js";
import Log from "@/api/log.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    // Currency,
    RawHtml,
    // ThumbnailText,
    // Thumbnail,
    // RawHtmlLimitNumber,
    StateLabel,
    // TinymceEditor,
  },
  data() {
    return {
      activeName: "detail",
      rentItem: { workflowState: "newly" },
      logs: [],
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getRentItem();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
    },
    getRentItem() {
      const self = this;
      self.loadingStart();
      RentItem.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.rentItem = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getLogs() {
      const self = this;
      Log.forEntity("RentItem", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
  },
};
</script>